import { Field, Form, Formik } from 'formik'
import React from 'react'
import WrapperAccordion from '../general/WrapperAccordion'
import FieldWrapper from './FieldWrapper'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import ImageDisplayAndUpload from './fields/ImageDisplayAndUpload'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import { EDIT_NEWSLETTER_CAP } from '../../constants/caps'
import { withRouter } from 'react-router-dom'

const FormNewsletterElementImage = ({
    itemData,
    closePagePath,
    onUpdateItem,
    history
}) => {
    return (
        <Formik
            initialValues={sanitizeFormInput(itemData)}
            onSubmit={(values, actions) => {
                onUpdateItem('images', sanitizeFormOutput(values))
                history.push(closePagePath)
            }}
            
            onReset={(values, actions) => {
                history.push(closePagePath)
            }}
        >
        {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
                <Form>
                    <WrapperAccordion
                        className="single-section"
                        selectionActiveClass="accordion-item-open"
                    >
                        <fieldset>
                            <div className="form-content highlight">
                                <div className="left-sections">
                                    <FieldWrapper label="" id="text" classes="field-textarea field-textarea-text">
                                        <Field 
                                            name="img"
                                            component={ImageDisplayAndUpload}
                                        />
                                    </FieldWrapper>    
                                </div>
                            </div>
        
                            <ButtonSubmitCancel
                                transIdCancel="cancel_button"
                                transIdSubmit="save_item_button"
                                cap={EDIT_NEWSLETTER_CAP}
                                disabledCancel={isSubmitting}
                                disabledSubmit={isSubmitting}
                                onCancel={handleReset}
                            />
                        </fieldset>
                    </WrapperAccordion>
                </Form>
            )}
        </Formik>
    )
}

export default withRouter(FormNewsletterElementImage)